<template>
  <article class="layout-section__container">
    <h3 class="layout-section__heading -spacing">Christmas / Winter</h3>

    <ul class="grid-icon">
      <li class="grid-icon__item">
        <svg-icon id="xmas-card3" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-ornement1" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-flower" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-label3" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-deer" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-flocon3" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-gift" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-socks" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-label2" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-jam" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-tea" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-snowman" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-snowflake" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-pine" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-hat" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-card1" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-courone" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-snowflake4" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-bell" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-cardinal" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-ornement2" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-coffee" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-flocon4" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-card2" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-candle" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-label" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-mitten" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-glass" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-star" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="xmas-ornement3" />
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  name: 'WorkIconsXmas'
}
</script>
